<template>
  <div class="filter-panel">
    <button
      v-if="collapsible"
      type="button"
      class="filter-panel__header filter-panel__header--collapsible"
      :class="{ 'filter-panel__header--open': open }"
      :aria-expanded="String(open)"
      :aria-controls="id"
      @click="$emit('toggle')"
    >
      <span class="filter-panel__title">{{ title }}</span>
      <vb-icon
        class="filter-panel__chevron"
        :name="'chevron-down'"
        :size="14"
        :color="sass('dark')"
      />
    </button>
    <div v-else-if="title" class="filter-panel__header">
      <span class="filter-panel__title">{{ title }}</span>
    </div>

    <b-collapse v-if="collapsible" :id="id" :visible="open">
      <div class="filter-panel__body" :class="body_class" :style="body_style">
        <slot></slot>
      </div>
    </b-collapse>
    <div v-else class="filter-panel__body" :class="body_class" :style="body_style">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'filter-panel',

    props: {
      title: {
        type: String,
        default: '',
      },
      id: {
        type: String,
        default: '',
      },
      collapsible: {
        type: Boolean,
        default: false,
      },
      open: {
        type: Boolean,
        default: false,
      },
      max_height: {
        type: Number,
        default: 0,
      },
    },

    computed: {
      body_class() {
        return this.max_height > 0 ? 'filter-panel__body--scrollable' : '';
      },
      body_style() {
        return this.max_height > 0
          ? { maxHeight: `${this.max_height}px` }
          : {};
      },
    },
  };
</script>

<style lang="scss" scoped>
  .filter-panel {
    padding: $grid-gutter-width / 2;
    border-bottom: 1px solid $gray-200;

    &:last-child {
      border-bottom: none;
    }

    &__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: $grid-gutter-width / 2;
      margin-bottom: $grid-gutter-width / 3;

      &--collapsible {
        appearance: none;
        width: 100%;
        padding: 0;
        margin-bottom: 0;
        background: none;
        border: 0;
        color: inherit;
        font: inherit;
        cursor: pointer;
      }

      &--open {
        margin-bottom: $grid-gutter-width / 3;

        .filter-panel__chevron {
          transform: rotate(-180deg);
        }
      }
    }

    &__title {
      font-size: $font-size-base;
      font-weight: $vb-font-weight-semibold;
    }

    &__chevron {
      flex-shrink: 0;
      transition: transform 0.2s ease-in-out;
    }

    &__body {
      &:empty {
        display: none;
      }

      &--scrollable {
        overflow-y: auto;
        @include scrollbar;
      }
    }
  }
</style>
